<template>
    <div class="ScenarioError">
        <v-menu bottom offset-y>
            <template v-slot:activator="props">
                <div class="error-container" v-on="props.on">
                    <v-icon small color="#fff" class="mr-1">mdi-alert-circle-outline</v-icon>
                    {{ errorList.length }}
                </div>
            </template>
            <div class="fci-list fci-scrollbar" style="max-height: 500px; overflow: auto">
                <div
                    class="fci-list-item"
                    v-for="(error, i) in errorList"
                    :key="i"
                    @click="revealError(error)"
                >
                    <v-icon
                        small
                        class="mr-1"
                        :color="error.priority === 1 ? 'red' : 'yellow'"
                    >mdi-alert-circle-outline</v-icon>
                    {{ error.title }}
                </div>
            </div>
        </v-menu>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ScenarioError',
    computed: {
        ...mapState({
            errorList: state => state.scenario.errorList
        })
    },
    methods: {
        scanError () {
            this.$store.dispatch(this.$at.scenario.SCAN_ERROR)
        },
        revealError (error) {
            if (error.data.type === 'step') {
                this.$store.dispatch(this.$at.scenario.ACTIVE_DATA, {
                    activeStepCode: error.data.step.code
                })
            } else if (error.data.type === 'card') {
                this.$store.dispatch(this.$at.scenario.ACTIVE_DATA, {
                    activeCardCode: error.data.card.code
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.error-container {
    background: #E55151;
    color: #fff;
    height: 20px;
    padding: 5px;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 4px #0000001A;
    border-radius: 100px;
    user-select: none;
    cursor: pointer;
}
</style>
